import { Platform } from 'react-native';

function ensureLink(rel: string, href: string, extra?: Record<string, string>) {
  const selector = extra?.sizes
    ? `link[rel="${rel}"][sizes="${extra.sizes}"]`
    : `link[rel="${rel}"][href="${href}"]`;
  let el = document.head.querySelector(selector) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
  if (extra) {
    for (const [k, v] of Object.entries(extra)) el.setAttribute(k, v);
  }
}

function ensureMeta(name: string, content: string) {
  let el = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function injectInstallTags() {
  if (typeof document === 'undefined') return;
  ensureLink('manifest', '/manifest.webmanifest');
  ensureLink('apple-touch-icon', '/pwa/apple-touch-icon.png', { sizes: '180x180' });
  ensureMeta('theme-color', '#A20000');
  ensureMeta('mobile-web-app-capable', 'yes');
  ensureMeta('apple-mobile-web-app-capable', 'yes');
  ensureMeta('apple-mobile-web-app-title', 'As Gastronómico');
  ensureMeta('apple-mobile-web-app-status-bar-style', 'default');
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    const content = viewport.getAttribute('content') || '';
    if (!content.includes('viewport-fit')) {
      viewport.setAttribute('content', `${content}, viewport-fit=cover`);
    }
  }
}

async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  try {
    await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      updateViaCache: 'none',
    });
  } catch (error) {
    console.warn('[pwa] No se pudo registrar el service worker', error);
  }
}

/** Manifest + SW sin caché de la app. Solo web. */
export function registerPwa() {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  injectInstallTags();
  const start = () => {
    void registerServiceWorker();
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
}
